import { render } from "./AlertPopup.vue?vue&type=template&id=d807f1b6&scoped=true"
import script from "./AlertPopup.vue?vue&type=script&lang=js"
export * from "./AlertPopup.vue?vue&type=script&lang=js"

import "./AlertPopup.vue?vue&type=style&index=0&id=d807f1b6&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d807f1b6"]])

export default __exports__